module.exports = __webpack_public_path__ + "img/logo.fff3ca3b.png";